'use strict';

module.exports = '_sugar_';


// WEBPACK FOOTER //
// ./~/sugar-date/common/var/PRIVATE_PROP_PREFIX.js